<template>
  <div>
    <div class="target-row wrap" v-if="intSettingExpandForLinks === 0" :class="lastofrowclass">
      <div class="target-primaryheader" v-if="primaryheadervisible">
        <div class="targetbox-content"><span v-html="primaryheadertext"></span></div>
      </div>
      <div
        class="target-item-singlerows target-subheaderChevron-singlerow"
        v-if="subheadervisible"
        @click.prevent="togglegrouprow(tblProfGroupTargetGroupingID)"
      >
        <div class="targetbox-content">
          <font-awesome-icon :icon="toggleArrowSinglerows" />
        </div>
      </div>
      <!-- if targetid is not null, en groupName moet hier, maar wel alleen bij de eerste! anders krijgen de anderen ook  een header en dat moet niet -->
      <div
        class="target-item-singlerows target-subheader-singlerow"
        v-if="subheadervisible"
        @click.prevent="togglegrouprow(tblProfGroupTargetGroupingID)"
      >
        <div class="targetbox-content">{{ targetgroup.data.groupName }}</div>
      </div>
      <div class="target-item-singlerows target-subsubheaderempty" v-if="subsubheadervisible"></div>
      <div class="target-item-singlerows target-subsubheader" v-if="subsubheadervisible">
        <div class="targetbox-content">{{ targetHeader }}</div>
      </div>
      <!-- <div class="target-item target-item1" v-if="targetrowvisible">
        <div class="targetbox-content" @click.prevent="toggle(targetgroup.targetID)">
          <font-awesome-icon :icon="toggleArrowSubSubHeader"/>
        </div>
      </div>-->

      <div class="target-item-singlerows target-item-singlerow1" v-if="targetrowvisible">
        <div class="targetbox-content">
          <a :href="spE026Link" v-if="spE026Link !== null">
            <span v-html="targetURLNameDate"></span>
          </a>
          <span v-if="spE026Link === null && targetURLNameDate !== ''" v-html="targetURLNameDate"></span>
        </div>
      </div>
      <div class="target-item-singlerows target-item-singlerow2" v-if="targetrowvisible" :class="targetsinglerow2class">
        <div class="targetbox-content">
          <XVprogressbar
            v-bind="{
              nettoTarget: nettoTarget,
              normTarget: normTarget,
              progressTarget: progressTarget,
              targetCalcResult: tempPersonProfGroupTargetCalcResult,
              statustextTarget: status,
              settingprogbar: codeShowNormScoreStatusAndProgressSPE020,
            }"
          ></XVprogressbar>
        </div>
      </div>
    </div>

    <div class="target-row wrap" v-if="intSettingExpandForLinks === 1">
      <div class="target-primaryheader" v-if="primaryheadervisible">
        <div class="targetbox-content">{{ primaryheadertext }}</div>
      </div>
      <div
        class="target-item target-subheaderChevron"
        v-if="subheadervisible"
        @click.prevent="togglegrouprow(tblProfGroupTargetGroupingID)"
      >
        <div class="targetbox-content">
          <font-awesome-icon :icon="toggleArrowGroupHeader" />
        </div>
      </div>
      <!-- if targetid is not null, en groupName moet hier, maar wel alleen bij de eerste! anders krijgen de anderen ook  een header en dat moet niet -->
      <div
        class="target-item target-subheader"
        v-if="subheadervisible"
        @click.prevent="togglegrouprow(tblProfGroupTargetGroupingID)"
      >
        <div class="targetbox-content">{{ targetgroup.data.groupName }}</div>
      </div>
      <div class="target-item target-subsubheaderempty" v-if="subsubheadervisible"></div>
      <div class="target-item target-subsubheader" v-if="subsubheadervisible">
        <div class="targetbox-content">{{ targetHeader }}</div>
      </div>
      <div
        class="target-item target-item1 pointer"
        v-if="targetrowvisible"
        @click.prevent="toggle(targetgroup.targetID)"
      >
        <div
          class="targetbox-content"
          v-if="this.spE026Link !== null || this.spE060Link !== null || this.wizardDossierLink !== null"
        >
          <font-awesome-icon :icon="toggleArrowSubSubHeader" />
        </div>
        <div
          class="targetbox-content"
          v-if="this.spE026Link === null && this.spE060Link === null && this.wizardDossierLink === null"
        >
          <font-awesome-icon icon="chevron-down" class="disabledarrow" />
        </div>
      </div>
      <div
        class="target-item target-item2 pointer"
        v-if="targetrowvisible"
        @click.prevent="toggle(targetgroup.targetID)"
      >
        <div class="targetbox-content">
          <span v-html="targetURLNameDate"></span>
        </div>
      </div>
      <div class="target-item target-item3" :class="targetitem3class" v-if="targetrowvisible">
        <div class="targetbox-content">
          <XVprogressbar
            v-bind="{
              nettoTarget: nettoTarget,
              normTarget: normTarget,
              progressTarget: progressTarget,
              targetCalcResult: tempPersonProfGroupTargetCalcResult,
              statustextTarget: status,
              settingprogbar: codeShowNormScoreStatusAndProgressSPE020,
            }"
          ></XVprogressbar>
        </div>
      </div>
      <div class="target-item target-targetbuttonrowempty" v-if="btnrowvisible"></div>
      <div class="target-item target-targetbuttonrow" v-if="btnrowvisible">
        <div class="targetbox-content">
          <!-- <font-awesome-icon :icon="['far', 'level-up']" class="spe020arrowicon"/>&nbsp; -->
          <button
            type="button"
            id="btn026Detail"
            class="btn btn-default targetbuttons btn-xs"
            @click.prevent="btn026Detail"
            v-if="spE026Link !== null"
          >
            <font-awesome-icon :icon="['far', 'eye']" />&nbsp;
            <span v-html="translation(15280)"></span>
          </button>
          <button
            type="button"
            id="btn060link"
            class="btn btn-default targetbuttons btn-xs"
            @click.prevent="btn060link"
            v-if="spE060Link !== null"
          >
            <span v-html="translation(spE060LinkTextID)"></span>
          </button>
          <button
            type="button"
            id="btnWizardDossier"
            class="btn btn-default targetbuttons btn-xs"
            @click.prevent="btnWizardDossier"
            v-if="wizardDossierLink !== null"
          >
            <span v-html="translation(wizardDossierLinkTextID)"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FAMixin } from 'pevueglobal'
export default {
  mixins: [FAMixin],
  props: [
    'tempTargetID',
    'tempCalcStartDate',
    'tempPersonProfGroupTargetCalcEndDate',
    'primSeq',
    'secSeq',
    'targetURLNameDate',
    'spE026Link',
    'wizardDossierLink',
    'wizardDossierLinkTextID',
    'spE060Link',
    'spE060LinkTextID',
    'status',
    'codeShowNormScoreStatusAndProgressSPE020',
    'tempPersonProfGroupTargetCalcResult',
    'normTarget',
    'nettoTarget',
    'progressTarget',
    'targetHeader',
    'tblProfGroupTargetGroupingID',
    'targetCodeExpand',
    'targetgroup',
    'toggle',
    'intSettingExpandForLinks',
    'togglegrouprow',
  ],
  computed: {
    primaryheadervisible() {
      return (
        (this.targetgroup.firstTargetofGroup === true && this.targetgroup.data.groupHeaderText !== '') ||
        (this.tblProfGroupTargetGroupingID === null && this.targetHeader !== '')
      )
    },
    primaryheadertext() {
      if (this.targetgroup.firstTargetofGroup === true && this.targetgroup.data.groupHeaderText !== '') {
        return this.targetgroup.data.groupHeaderText
      } else if (this.tblProfGroupTargetGroupingID === null && this.targetHeader !== '') {
        return this.targetHeader
      } else {
        return ''
      }
    },
    subheadervisible() {
      return this.targetgroup.firstTargetofGroup === true && this.targetgroup.data.groupName !== ''
    },
    subsubheadervisible() {
      return (
        this.tblProfGroupTargetGroupingID !== null &&
        this.targetHeader !== '' &&
        this.targetgroup.togglegrouprow === true
      )
    },
    targetrowvisible() {
      return this.targetgroup.togglegrouprow === true || this.tblProfGroupTargetGroupingID === null
    },
    btnrowvisible() {
      // check of er buttons in btnwor staan gedaan n.a.v. een lege row die zichtbaar was als er geen button stond, en chevron onklikbaar was.
      return (
        (this.targetgroup.togglerow === true &&
          this.targetgroup.togglegrouprow === true &&
          (this.spE026Link !== null || this.spE060Link !== null || this.wizardDossierLink !== null)) ||
        (this.targetgroup.togglerow === true &&
          this.tblProfGroupTargetGroupingID === null &&
          (this.spE026Link !== null || this.spE060Link !== null || this.wizardDossierLink !== null))
      )
    },
    toggleArrowSubSubHeader() {
      return this.targetgroup.togglerow === true ? 'chevron-up' : 'chevron-down'
    },
    toggleArrowGroupHeader() {
      return this.targetgroup.togglegrouprow === true ? ['far', 'chevron-square-up'] : ['far', 'chevron-square-down']
    },
    toggleArrowSinglerows() {
      return this.targetgroup.togglegrouprow === true ? 'chevron-up' : 'chevron-down'
    },
    lastofrowclass() {
      return this.targetgroup.lastTargetofGroup === true && this.targetgroup.togglegrouprow === true
        ? 'lasttargetofgroup'
        : ''
    },
    targetitem3class() {
      if ((this.wSM === true || this.wXS === true) && this.codeShowNormScoreStatusAndProgressSPE020 === 1) {
        return 'target-item-3-empty'
      }
      if (
        this.codeShowNormScoreStatusAndProgressSPE020 === 7 ||
        this.codeShowNormScoreStatusAndProgressSPE020 === 8 ||
        this.codeShowNormScoreStatusAndProgressSPE020 === 9
      ) {
        return 'target-item-3-progressbar'
      } else {
        return ''
      }
    },
    targetsinglerow2class() {
      if ((this.wSM === true || this.wXS === true) && this.codeShowNormScoreStatusAndProgressSPE020 === 1) {
        return 'target-singlerow-2-empty'
      }
      if (
        this.codeShowNormScoreStatusAndProgressSPE020 === 7 ||
        this.codeShowNormScoreStatusAndProgressSPE020 === 8 ||
        this.codeShowNormScoreStatusAndProgressSPE020 === 9
      ) {
        return 'target-singlerow-2-progressbar'
      } else {
        return ''
      }
    },
  },
  methods: {
    btn026Detail() {
      if (this.spE026Link.indexOf('peapp') === -1) {
        window.location = this.spE026Link
      } else {
        this.$router.push({ path: this.spE026Link })
      }
    },
    btn060link() {
      if (this.spE060Link.indexOf('peapp') === -1) {
        window.location = this.spE060Link
      } else {
        this.$router.push({ path: this.spE060Link })
      }
    },
    btnWizardDossier() {
      if (this.wizardDossierLink.indexOf('peapp') === -1) {
        window.location = this.wizardDossierLink
      } else {
        this.$router.push({ path: this.wizardDossierLink })
      }
    },
  },
}
</script>

<style>
.test {
  width: 100%;
}
.target-row {
  padding: 0;
  margin: 0;
  border: 0;
  -ms-box-orient: horizontal;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -moz-flex;
  display: -webkit-flex;
  display: flex;
}
.wrap {
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
.target-item-singlerows {
  font-weight: normal;
  font-size: 13px;
  padding: 10px 10px 10px 10px;
}
.target-item,
.target-primaryheader {
  font-weight: normal;
  font-size: 13px;
}
.target-primaryheader {
  width: 100%;
  text-align: left;
  padding: 10px 10px 10px 10px;
}
.target-item,
.target-item-singlerows {
  color: currentColor;
}
.target-header {
  padding: 10px 10px 10px 10px;
}
.target-item-singlerow1 {
  width: 65%;
  text-align: left;
  padding-left: 10px;
}
.target-item-singlerow2 {
  width: 35%;
  text-align: left;
}
.target-item1 {
  width: 8%;
  text-align: center;
  padding-top: 15px;
}
.target-item2 {
  width: 57%;
  text-align: left;
  padding: 15px 10px 15px 0px;
}
.target-item3 {
  width: 35%;
  text-align: left;
  padding: 15px 10px 15px 10px;
}
.target-targetbuttonrowempty {
  min-height: 35px;
  width: 8%;
}
.target-targetbuttonrow {
  min-height: 35px;
  width: 92%;
  text-align: left;
  line-height: 0px;
}
.target-subheader-singlerow {
  width: 97%;
  background-color: #c6c6c6;
  font-weight: bold;
  padding: 10px 10px 10px 0px;
}
.target-subheaderChevron-singlerow {
  width: 3%;
  text-align: left;
  background-color: #c6c6c6;
  padding: 10px 10px 10px 10px;
}
.target-subheader {
  width: 92%;
  background-color: #c6c6c6;
  font-weight: bold;
  padding: 10px 10px 10px 0px;
}
.target-subheaderChevron {
  width: 8%;
  text-align: center;
  background-color: #c6c6c6;
  padding: 10px 10px 10px 10px;
}
.target-subsubheaderempty {
  width: 8%;
  background-color: #e0e0e0;
  padding: 10px 10px 10px 0px;
}
.target-subsubheader {
  width: 92%;
  background-color: #e0e0e0;
  font-weight: bold;
  padding: 10px 10px 10px 0px;
}
.target-item-3-progressbar {
  padding-top: 6px;
  padding-bottom: 6px;
}
.target-singlerow-2-progressbar {
  padding-top: 2px;
  padding-bottom: 2px;
}
.targetbuttons {
  vertical-align: top;
  margin-top: -10px;
}
.disabledarrow {
  color: #c6c6c6;
}
.lasttargetofgroup {
  border-bottom: 1px solid #c7c7c7;
}
/* bootstrap pixels aangehouden */
@media (max-width: 768px) {
  .target-item1 {
    width: 8%;
    background-color: #ededed;
    padding-top: 8px;
  }
  .target-item2,
  .target-item-singlerow1 {
    width: 92%;
    background-color: #ededed;
    padding: 8px 10px 8px 0px;
  }
  .target-item3,
  .target-item-singlerow2 {
    width: 100%;
    border-left-width: 3px;
    border-left-style: solid;
    padding: 8px 10px 12px 10px;
  }
  .target-item-singlerow1 {
    width: 100%;
  }
  .target-item-singlerow2 {
    width: 100%;
  }
  .target-subheader-singlerow {
    width: 91%;
  }
  .target-subheaderChevron-singlerow {
    width: 9%;
  }
  .target-targetbuttonrow {
    border-left-width: 3px;
    border-left-style: solid;
    width: 100%;
    margin-top: 0;
    padding: 8px 10px 8px 10px;
  }
  .target-targetbuttonrowempty {
    display: none;
  }
  #btn026Detail,
  #btn060link,
  #btnWizardDossier {
    height: 30px;
    width: 100%;
    margin-bottom: 10px;
  }
  .target-item-3-empty,
  .target-singlerow-2-empty {
    display: none;
  }
  .target-subsubheaderempty {
    padding: 8px 10px 8px 0px;
  }
  .target-subsubheader {
    width: 92%;
    background-color: #e0e0e0;
    font-weight: bold;
    padding: 10px 10px 10px 0px;
  }
  .targetbuttons {
    margin-top: 0px;
  }
}
</style>
